import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { socialTrackEvents } from 'src/common/page-share/page-share.constants';
import { type SocialLinks, SocialName } from 'src/common/page-share/page-share.types';
import { useSocialLinks } from 'src/common/page-share/use-social-links';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledMiniSocialButton } from 'src/common/styles';
import type { SegmentShareEvent } from 'src/common/types';
import { StyledWrapperButtons } from './streak-social-share.styles';
export const StreakSocialSharing = ({
  streakUrl,
  socialLinks = {
    [SocialName.twitter]: true,
    [SocialName.linkedin]: true,
    [SocialName.facebook]: true,
    [SocialName.reddit]: true,
    [SocialName.whatsapp]: true,
    [SocialName.telegram]: true
  }
}: {
  streakUrl: string;
  socialLinks?: SocialLinks;
}) => {
  const filteredLinks = useSocialLinks(socialLinks);
  const [trackEvent] = useTrackEventMutation();
  const location = useLocation();
  const trackShareClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        page: location.pathname,
        achievement: 'streak',
        medium: source,
        clicked_on: source,
        name: 'streak'
      }
    });
  }, [trackEvent, location.pathname]);
  return <StyledWrapperButtons data-sentry-element="StyledWrapperButtons" data-sentry-component="StreakSocialSharing" data-sentry-source-file="streak-social-share.tsx">
      {filteredLinks.map(social => <StyledMiniSocialButton key={social.name} data-social={social.name} href={social.href({
      description: 'Learning streak in full swing!',
      url: streakUrl,
      campaign: {
        utmContent: 'streak'
      }
    })} target="_blank" onClick={() => trackShareClick(socialTrackEvents[social.name])}>
          <social.icon />
        </StyledMiniSocialButton>)}
    </StyledWrapperButtons>;
};